import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useGetLanguage = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language);
  useEffect(() => {
    function listener(newLang: string) {
      setCurrentLanguage(newLang);
    }
    i18n.on('languageChanged', listener);
    return () => {
      i18n.off('languageChanged', listener);
    };
  }, [i18n]);
  return { currentLanguage };
};
